// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__2_mst","border":"Avatar_border__20vHO"};